import { render, staticRenderFns } from "./diaMobileList.vue?vue&type=template&id=64fa0242&scoped=true&"
import script from "./diaMobileList.vue?vue&type=script&lang=js&"
export * from "./diaMobileList.vue?vue&type=script&lang=js&"
import style0 from "./diaMobileList.vue?vue&type=style&index=0&id=64fa0242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa0242",
  null
  
)

export default component.exports